import {EdcUiFeature} from '../edc-ui-feature';

export const COMMUNITY_EDITION_FEATURES: EdcUiFeature[] = [
  // 'open-source-marketing',
];
